import React from 'react';

type BrowserFrameProps = {
  src: string;
  alt: string;
  loading?: 'eager' | 'lazy';
  imageClassName?: string;
};

const BrowserFrame: React.FC<BrowserFrameProps> = ({
  src,
  alt,
  loading = 'lazy',
  imageClassName,
}) => {
  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="flex items-center gap-2 border-b border-slate-200 bg-slate-50 px-4 py-3">
        <div className="flex items-center gap-2">
          <span className="h-3 w-3 rounded-full bg-red-300" />
          <span className="h-3 w-3 rounded-full bg-yellow-300" />
          <span className="h-3 w-3 rounded-full bg-green-300" />
        </div>
        <div className="ml-4 h-2 w-1/3 rounded-full bg-slate-200" />
      </div>
      <img
        src={src}
        alt={alt}
        loading={loading}
        className={imageClassName ?? 'h-auto w-full bg-white'}
      />
    </div>
  );
};

export default BrowserFrame;
